module.exports = __webpack_public_path__ + "img/Facilities.0af872fa.png";